import { ArrowRight, LoaderCircle } from "lucide-react";
import { motion } from "framer-motion";
import { useJourney } from "./JourneyContext";

export const JourneyLanding = () => {
  const { begin, working, error } = useJourney();
  return (
    <section className="journey-landing" data-testid="intention-landing">
      <div className="journey-landing-orb" aria-hidden="true"><i /><i /><i /></div>
      <div className="journey-landing-copy">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1.2 }}>DON’T TELL US WHO YOU ARE.</motion.p>
        <motion.h1 initial={{ opacity: 0, filter: "blur(16px)" }} animate={{ opacity: 1, filter: "blur(0px)" }} transition={{ delay: .7, duration: 1.2 }}>SHOW US<br /><em>WHAT PULLS YOU.</em></motion.h1>
        <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.5 }}>7 moments.<br />No right answers.<br />Just instinct.</motion.span>
        <motion.button type="button" onClick={begin} disabled={working} data-testid="journey-start-button" initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 2 }}>
          {working ? <LoaderCircle className="animate-spin" size={18} /> : <ArrowRight size={18} />}<strong>{working ? "OPENING THE JOURNEY" : "BEGIN"}</strong>
        </motion.button>
        {error && <p className="intention-error" role="alert" data-testid="journey-start-error">{error}</p>}
      </div>
      <div className="journey-landing-brand"><img src="/brand/humn-mark.png" alt="" /><span>HUMN · FROM ATTENTION TO INTENTION</span></div>
    </section>
  );
};